import axiosService from '../plugins/axiosService'

export default {
    async serviceAll(){
        return axiosService.get('/api/service/all')
    }
}
